import { toUserInfo,listByUser,listSelf,list_self_new,selfAdd,infoByUser,remarkInfoByUser,remarkAdd,remarkUpdata,listCustUser } from '@/api/sessiom'

const actions = {
    toUserInfo(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            toUserInfo(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listByUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listByUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listSelf(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listSelf(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    list_self_new(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            list_self_new(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    selfAdd(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            selfAdd(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    infoByUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            infoByUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    remarkInfoByUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            remarkInfoByUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    remarkAdd(state, info){
        const infoData = info
        return new Promise((resolve,reject) => {
            remarkAdd(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    remarkUpdata(state, info){
        const infoData = info
        return new Promise((resolve,reject) => {
            remarkUpdata(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listCustUser(state, info){
        const infoData = info
        return new Promise((resolve,reject) => {
            listCustUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },

}

export default {
  namespaced: true,
  actions
}
